import type { Step } from "../script";

export const sparkConnectDrift: Step[] = [
  {
    kind: "msg",
    id: "msg-02a",
    tokens:
      "sparkconnect drifted to 1.11% overnight. at this ramp, breach of the 1.5% merchant ceiling in ~4 months.",
    pauseAfter: 1100,
  },
  {
    kind: "panel",
    view: "intelligence",
    focus: { kind: "merchant", merchantId: "MID-026" },
    pauseAfter: 1300,
  },
  {
    kind: "msg",
    id: "msg-02b",
    tokens:
      "applying 3ds @ 60% on visa renewals for 90 days. ~45% fraud reduction, +4 months runway. override to hold.",
    pauseAfter: 900,
  },
  {
    kind: "act",
    id: "act-sparkconnect",
    title: "3ds step-up · sparkconnect · bin 486201",
    body: "60% gate · 90 days · breach 4mo → 13mo",
    receipt: "SPARKCONNECT · BIN 486201 · 3DS @ 60% · 90d · applied",
    actMs: 5800,
  },
  {
    kind: "msg",
    id: "msg-02c",
    tokens: "done. managed trajectory drawn on the panel.",
    pauseAfter: 1100,
  },
];
